module.exports = __webpack_public_path__ + "img/2@2x.bc59ab4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/2@2x.png
// module id = jkWL
// module chunks = 0